<template>
    <div class="institution-rating-item">
        <!-- 左侧：机构 Logo + 名称 -->
        <div class="institution-rating-item__left">
            <div class="institution-rating-item__logo">
                <img v-if="logo" :src="logo" :alt="name" />
                <span v-else class="institution-rating-item__logo-placeholder">{{ name ? name.charAt(0) : '' }}</span>
            </div>
            <div class="institution-rating-item__info">
                <span class="institution-rating-item__name">{{ name }}</span>
                <div class="institution-rating-item__details-row">
                    <div class="institution-rating-item__details">
                        <span class="institution-rating-item__label">{{ $t('rating') }}</span>
                        <span class="institution-rating-item__rating" :class="ratingClass">{{ rating }}</span>
                    </div>
                    <div class="institution-rating-item__details">
                        <span class="institution-rating-item__label">{{ $t('target') }}</span>
                        <span class="institution-rating-item__target">{{ target }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧：Latest 标签 + 日期 -->
        <div class="institution-rating-item__right">
            <LatestBadge v-if="isLatest" :text="$t('latest')" />
            <span class="institution-rating-item__date">{{ date }}</span>
        </div>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
import LatestBadge from '../../assets/uis/LatestBadge.vue';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  logo: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  rating: {
    type: String,
    default: 'Buy'
  },
  target: {
    type: [String, Number],
    default: ''
  },
  date: {
    type: String,
    default: ''
  },
  isLatest: {
    type: Boolean,
    default: false
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 多语言
  const $t = useI18n(props.languageId);
  const ratingClass = computed(() => {
    const r = props.rating.toLowerCase();
    if (r === 'buy' || r === 'strong buy' || r === '买入') return 'institution-rating-item__rating--buy';
    if (r === 'sell' || r === 'strong sell' || r === '卖出') return 'institution-rating-item__rating--sell';
    return 'institution-rating-item__rating--hold';
  });
  return {
    $t,
    ratingClass
  };
};
__sfc_main.components = Object.assign({
  LatestBadge
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.institution-rating-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.24rem 0;
    border-bottom: 0.02rem solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }

    &__left {
        display: flex;
        gap: 0.1rem;
    }

    &__logo {
        width: 0.45rem;
        height: 0.45rem;
        border-radius: 0.225rem;
        overflow: hidden;
        background: #1a5c4c;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__logo-placeholder {
        font-size: 0.18rem;
        font-weight: 600;
        color: #ffffff;
        text-transform: uppercase;
    }

    &__info {
        display: flex;
        flex-direction: column;
        gap: 0.08rem;
    }

    &__name {
        font-weight: 600;
        color: #262626;
        font-size: 0.26rem;
        line-height: 0.34rem;
        letter-spacing: -0.01rem;
    }

    &__details-row {
        display: flex;
        flex-direction: row;
        gap: 0.2rem;
    }

    &__details {
        display: flex;
        align-items: center;
        gap: 0.08rem;
    }

    &__label {
        font-size: 0.26rem;
        font-weight: 400;
        color: #626262;
    }

    &__rating {
        font-size: 0.26rem;
        font-weight: 500;

        &--buy {
            color: #00a843;
        }

        &--sell {
            color: #d12626;
        }

        &--hold {
            color: #626262;
        }
    }

    &__target {
        font-size: 0.26rem;
        font-weight: 600;
        color: #000000;
    }

    &__right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 0.08rem;
    }

    &__date {
        font-size: 0.22rem;
        color: #626262;
        line-height: 0.3rem;
    }
}
</style>
